/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Domain_Search_Modal_Get_Free_TitleInputs */

const en_domain_search_modal_get_free_title = /** @type {(inputs: Domain_Search_Modal_Get_Free_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get a Free Custom Domain`)
};

const es_domain_search_modal_get_free_title = /** @type {(inputs: Domain_Search_Modal_Get_Free_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obtén un Dominio Personalizado Gratis`)
};

const fr_domain_search_modal_get_free_title = /** @type {(inputs: Domain_Search_Modal_Get_Free_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obtenir un domaine personnalisé gratuit`)
};

const de_domain_search_modal_get_free_title = /** @type {(inputs: Domain_Search_Modal_Get_Free_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hol dir eine kostenlose benutzerdefinierte Domain`)
};

/** @type {(inputs: Domain_Search_Modal_Get_Free_TitleInputs) => LocalizedString} */
const ja_domain_search_modal_get_free_title = en_domain_search_modal_get_free_title;

/** @type {(inputs: Domain_Search_Modal_Get_Free_TitleInputs) => LocalizedString} */
const zh_domain_search_modal_get_free_title = en_domain_search_modal_get_free_title;

/** @type {(inputs: Domain_Search_Modal_Get_Free_TitleInputs) => LocalizedString} */
const ar_domain_search_modal_get_free_title = en_domain_search_modal_get_free_title;

/** @type {(inputs: Domain_Search_Modal_Get_Free_TitleInputs) => LocalizedString} */
const id_domain_search_modal_get_free_title = en_domain_search_modal_get_free_title;

/** @type {(inputs: Domain_Search_Modal_Get_Free_TitleInputs) => LocalizedString} */
const it_domain_search_modal_get_free_title = en_domain_search_modal_get_free_title;

/** @type {(inputs: Domain_Search_Modal_Get_Free_TitleInputs) => LocalizedString} */
const ru_domain_search_modal_get_free_title = en_domain_search_modal_get_free_title;

/** @type {(inputs: Domain_Search_Modal_Get_Free_TitleInputs) => LocalizedString} */
const pt_domain_search_modal_get_free_title = en_domain_search_modal_get_free_title;

/** @type {(inputs: Domain_Search_Modal_Get_Free_TitleInputs) => LocalizedString} */
const ko_domain_search_modal_get_free_title = en_domain_search_modal_get_free_title;

/**
* | output |
* | --- |
* | "Get a Free Custom Domain" |
*
* @param {Domain_Search_Modal_Get_Free_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const domain_search_modal_get_free_title = /** @type {((inputs?: Domain_Search_Modal_Get_Free_TitleInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Domain_Search_Modal_Get_Free_TitleInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_domain_search_modal_get_free_title(inputs)
	if (locale === "es") return es_domain_search_modal_get_free_title(inputs)
	if (locale === "fr") return fr_domain_search_modal_get_free_title(inputs)
	if (locale === "de") return de_domain_search_modal_get_free_title(inputs)
	if (locale === "ja") return ja_domain_search_modal_get_free_title(inputs)
	if (locale === "zh") return zh_domain_search_modal_get_free_title(inputs)
	if (locale === "ar") return ar_domain_search_modal_get_free_title(inputs)
	if (locale === "id") return id_domain_search_modal_get_free_title(inputs)
	if (locale === "it") return it_domain_search_modal_get_free_title(inputs)
	if (locale === "ru") return ru_domain_search_modal_get_free_title(inputs)
	if (locale === "pt") return pt_domain_search_modal_get_free_title(inputs)
	return ko_domain_search_modal_get_free_title(inputs)
});